import React from "react";
import "./HasAccess.css";
import WarningIcon from "@mui/icons-material/Warning";
import { yellow } from "@mui/material/colors";

const HasAccess = () => {
  return (
    <div className="has-access-div">
      <WarningIcon
        sx={{
          color: yellow[500],
          width: "26px",
          height: "26px",
          paddingRight: "10px",
        }}
        fontSize="small"
      />{" "}
      We regret to inform you that PricePinger is currently not available in
      your country
    </div>
  );
};

export default HasAccess;
